import { IChatDashboardSettings } from '../types';

export const AT_UPDATE = 'CHAT_DASHBOARD_SETTINGS_UPDATE';

export interface IUpdateAction {
    type: typeof AT_UPDATE;
    chatDashboardSettings: IChatDashboardSettings;
}

export type TChatDashboardSettingsAction = (IUpdateAction);
